<template>
  <v-card flat>
    <slot name="header">
      <v-card-title v-if="!hideHeader">
        <v-row align="center">
          <v-col cols="12" md="6">
            <slot name="title">Class Holidays</slot>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="12" md="auto" class="text-right">
            <holiday-form-dialog
              v-model="addDialog"
              mode="add"
              :classroom-id="classroomId"
              submit-api
              @submit="onSubmitAddHoliday"
            >
              <template #activator="{ on, attrs }">
                <v-btn
                  color="success"
                  depressed
                  :block="$vuetify.breakpoint.mobile"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon left>mdi-plus</v-icon>Tambah
                </v-btn>
              </template>
            </holiday-form-dialog>
          </v-col>
        </v-row>
      </v-card-title>
      <v-divider v-if="!hideHeader"></v-divider>
    </slot>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="itemList.data"
        :loading="isLoading"
        :options.sync="options"
        :server-items-length="itemList.meta.total"
        item-key="id"
      >
        <template #[`item.name`]="{ item }">
          {{ bilingualText(item, 'name', 'name_cn') }}
        </template>
        <template #[`item.start_date`]="{ item }">
          {{ formatDate(item.start_date, 'DD MMM YYYY') }}
        </template>
        <template #[`item.end_date`]="{ item }">
          {{ formatDate(item.end_date, 'DD MMM YYYY') }}
        </template>
        <template #[`item.action`]="{ item }">
          <div class="text-right">
            <v-btn depressed color="error" small @click="removeHoliday(item)">
              <v-icon left>mdi-delete-forever</v-icon>Delete
            </v-btn>
            <v-btn depressed color="warning" small @click="editHoliday(item)">
              <v-icon left>mdi-pencil</v-icon>Edit
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-card-text>
    <holiday-form-dialog
      v-if="editDialog.show"
      v-model="editDialog.show"
      :item="editDialog.item"
      submit-api
      @submit="onSubmitEditHoliday"
    ></holiday-form-dialog>
    <holiday-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :holiday="deleteDialog.item"
      @delete="onSubmitDeleteHoliday"
    ></holiday-delete-dialog>
  </v-card>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import { ListParams } from '@/models'
import HolidayFormDialog from '@components/Classroom/HolidayFormDialog'
import HolidayDeleteDialog from '@components/Holiday/DeleteDialog'
import utils from '@/utils'
export default {
  name: 'ClassroomHolidayList',
  components: {
    HolidayFormDialog,
    HolidayDeleteDialog,
  },
  props: {
    classroomId: {
      type: Number,
      required: true,
    },
    hideHeader: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      filters: {
        classroom_id: null,
      },
      options: {
        page: 1,
        itemsPerPage: 50,
      },
      headers: [
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Start Date', value: 'start_date' },
        { text: 'End Date', value: 'end_date' },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Action', value: 'action', sortable: false },
      ],
      editDialog: {
        show: false,
        item: null,
      },
      addDialog: false,
      deleteDialog: {
        show: false,
        item: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'classroom/holidayList',
      isLoading: 'classroom/isHolidayListLoading',
    }),
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getItemList: 'classroom/getHolidayList',
      deleteHoliday: 'holiday/delete',
    }),
    ...mapMutations({
      setListParams: 'classroom/setHolidayListParams',
    }),
    async init() {
      if (this.classroomId) {
        this.filters.classroom_id = this.classroomId
      }
      await this.getListData()
    },
    async getListData() {
      const listParams = new ListParams(this.filters, this.options)
      await this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    removeHoliday(item) {
      this.deleteDialog.show = true
      this.deleteDialog.item = item
    },
    async onSubmitDeleteHoliday() {
      await this.getListData()
      this.deleteDialog.item = null
      this.deleteDialog.show = false
      this.$emit('deleted', true)
    },
    editHoliday(item) {
      this.editDialog.item = _.cloneDeep(item)
      this.editDialog.show = true
    },
    async onSubmitEditHoliday(item) {
      await this.getListData()
      this.editDialog.item = null
      this.editDialog.show = false
      this.$emit('updated', item)
    },
    async onSubmitAddHoliday(item) {
      this.addDialog = false
      await this.getListData()
      this.$emit('created', item)
    },
  },
}
</script>
